import styled from 'styled-components'

export const StyledRoutesContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-grow: 1;
  z-index: 10;
  overflow-x: ${props => props.user === 'true' && 'clip'};
`

export const StyledRoutes = styled.main<any>`
  z-index: 0;
  background-color: ${props => props.theme.secondary};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  position: relative;
`
